module.exports = __webpack_public_path__ + "static/paymentcloud@2x-7c16dd09b70f513fe762313d2460433f.png";